import { render, staticRenderFns } from "./VerticalNavMenuItem.vue?vue&type=template&id=123b986e&scoped=true&"
import script from "./VerticalNavMenuItem.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavMenuItem.vue?vue&type=style&index=0&id=123b986e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123b986e",
  null
  
)

export default component.exports